import { render } from "./MoveToStorageModal.vue?vue&type=template&id=07065732&scoped=true"
import script from "./MoveToStorageModal.vue?vue&type=script&lang=js"
export * from "./MoveToStorageModal.vue?vue&type=script&lang=js"

import "./MoveToStorageModal.vue?vue&type=style&index=0&id=07065732&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-07065732"]])

export default __exports__